import { render, staticRenderFns } from "./FormMobileRRPlagas.vue?vue&type=template&id=3ada639e&scoped=true"
import script from "./FormMobileRRPlagas.vue?vue&type=script&lang=js"
export * from "./FormMobileRRPlagas.vue?vue&type=script&lang=js"
import style0 from "./FormMobileRRPlagas.vue?vue&type=style&index=0&id=3ada639e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ada639e",
  null
  
)

export default component.exports